import type { Breakpoints } from '../../core/models/breakpoints';
import { PAYMENT_RULES_SLUG } from '../payment-rules/payment-rules';
import { FAQ_MENU_SLUG } from './faq-panels.const';

/**
 * Пункты навигации (шапка desktop, бургер mobile), ведущие на локальные страницы
 * `/<bp>/main/<path>` вместо CMS-маршрутов `menu/*`: slug → путь относительно `main`.
 */
const LOCAL_NAV_PAGES: ReadonlyMap<string, string> = new Map([
  [FAQ_MENU_SLUG, FAQ_MENU_SLUG],
  [PAYMENT_RULES_SLUG, PAYMENT_RULES_SLUG],
]);

/** Путь локальной страницы пункта относительно `/<bp>/main`; не локальный пункт — undefined. */
export function localNavPagePath(slug: string | undefined): string | undefined {
  return slug ? LOCAL_NAV_PAGES.get(slug) : undefined;
}

/** Slug пункта, чья локальная страница открыта по `url` (для активной подсветки), иначе undefined. */
export function activeLocalNavSlug(url: string, bp: `${Breakpoints}`): string | undefined {
  for (const [slug, path] of LOCAL_NAV_PAGES) {
    const prefix = `/${bp}/main/${path}`;
    if (url.startsWith(prefix) && /^(?:[/?#]|$)/.test(url.slice(prefix.length))) {
      return slug;
    }
  }
  return undefined;
}
